import { useEffect } from 'react'
import { NavLink, Route, Routes, useLocation } from 'react-router-dom'
import Start from './pages/Start'
import Kursplan from './pages/Kursplan'
import KursplanGy11 from './pages/KursplanGy11'
import KursplanAndringar from './pages/KursplanAndringar'
import KapitelSida from './pages/KapitelSida'
import LararhandledningOversikt from './pages/LararhandledningOversikt'
import ArbetsomradeSida from './pages/ArbetsomradeSida'
import LektionSida from './pages/LektionSida'
import BlockbibliotekSida from './pages/BlockbibliotekSida'
import SkrivUtAlla from './pages/SkrivUtAlla'
import BegreppOversikt from './pages/BegreppOversikt'
import BegreppSida from './pages/BegreppSida'
import ModellerOversikt from './pages/ModellerOversikt'
import ModellSida from './pages/ModellSida'
import ModellJamforelse from './pages/ModellJamforelse'
import KallorSida from './pages/KallorSida'
import Om from './pages/Om'
import SokSida from './pages/SokSida'

function SkrollaTillToppen() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default function App() {
  return (
    <>
      <SkrollaTillToppen />
      <header className="sidhuvud">
        <div className="wrap sidhuvud-rad">
          {/* aria-label krävs: på smala skärmar döljs logotyp-texten och märket är
              aria-hidden — utan etiketten står länken utan tillgängligt namn. */}
          <NavLink to="/" className="logotyp" aria-label="Ledarskap och organisation — till startsidan">
            <span className="logotyp-mark" aria-hidden="true">L&amp;O</span>
            <span className="logotyp-text">Ledarskap &amp; organisation</span>
          </NavLink>
          <div className="sidhuvud-hoger">
            <nav className="huvudnav" aria-label="Huvudmeny">
              <NavLink to="/" end className={({ isActive }) => (isActive ? 'aktiv' : '')}>
                Kapitel
              </NavLink>
              <NavLink to="/begrepp" className={({ isActive }) => (isActive ? 'aktiv' : '')}>
                Begrepp
              </NavLink>
              <NavLink to="/modeller" className={({ isActive }) => (isActive ? 'aktiv' : '')}>
                Modeller
              </NavLink>
              <NavLink to="/lararhandledning" className={({ isActive }) => (isActive ? 'aktiv' : '')}>
                Lärarhandledning
              </NavLink>
            </nav>
            <NavLink to="/sok" className={({ isActive }) => `sokikon${isActive ? ' aktiv' : ''}`} aria-label="Sök på sajten">
              🔍
            </NavLink>
          </div>
        </div>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Start />} />
          <Route path="/kursplan" element={<Kursplan />} />
          <Route path="/kursplan/gy11" element={<KursplanGy11 />} />
          <Route path="/kursplan/andringar" element={<KursplanAndringar />} />
          <Route path="/kapitel/:slug" element={<KapitelSida />} />
          <Route path="/begrepp" element={<BegreppOversikt />} />
          <Route path="/begrepp/:slug" element={<BegreppSida />} />
          <Route path="/modeller" element={<ModellerOversikt />} />
          <Route path="/modeller/jamfor" element={<ModellJamforelse />} />
          <Route path="/modeller/:teoriId" element={<ModellSida />} />
          <Route path="/kallor" element={<KallorSida />} />
          <Route path="/om" element={<Om />} />
          <Route path="/sok" element={<SokSida />} />
          <Route path="/skriv-ut" element={<SkrivUtAlla />} />
          <Route path="/lararhandledning" element={<LararhandledningOversikt />} />
          <Route path="/lararhandledning/blockbibliotek" element={<BlockbibliotekSida />} />
          <Route path="/lararhandledning/:aoId" element={<ArbetsomradeSida />} />
          <Route path="/lararhandledning/:aoId/lektion/:lektionId" element={<LektionSida />} />
          <Route path="*" element={<Start />} />
        </Routes>
      </main>
      <footer className="sidfot">
        <div className="wrap sidfot-rad">
          <span>Läromedel för ämnet Ledarskap och organisation, nivå 1 (Gy25)</span>
          <div className="sidfot-lankar">
            <NavLink to="/kursplan">Kursplan</NavLink>
            <NavLink to="/kallor">Källor</NavLink>
            <NavLink to="/om">Om läromedlet</NavLink>
          </div>
        </div>
      </footer>
    </>
  )
}
